type SystemScoped = {
	id?: number
	system?: { id?: number }
}

/** Keep rows that belong to the selected system when the payload includes a system reference. */
export const forSelectedSystem = <T extends SystemScoped>(items: T[], systemId: number): T[] => {
	const reportsSystem = items.some((item) => item.system?.id != null)
	if (!reportsSystem) return items.filter((item) => item.id != null)
	return items.filter((item) => item.id != null && item.system?.id === systemId)
}
